






























































import Vue, { PropOptions } from 'vue';
import type { QuoteCardType } from '@/components/storyblok/QuoteCard.vue';
import type { PaddingOptions } from '@/components/SectionContainer.vue';
import type { ProductHuntBadge } from '@/components/storyblok/ProductHuntBadge.vue';

export type Quotes = Blok & {
  title: string;
  quotes: QuoteCardType[];
  paddingTop?: PaddingOptions;
  paddingBottom?: PaddingOptions;
  productHuntBadge: ProductHuntBadge[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<Quotes>,
  },
  computed: {
    quotes(): QuoteCardType[] {
      return this.blok.quotes || [];
    },
    isSingleRow(): boolean {
      return this.quotes.length < 6;
    },
    disableAnimation(): boolean {
      return this.quotes.length < 3;
    },
    firstRowQuotes(): QuoteCardType[] {
      if (this.isSingleRow) {
        return this.quotes;
      }

      const middle = Math.ceil(this.quotes.length / 2);

      return this.quotes.slice(0, middle);
    },

    secondRowQuotes(): QuoteCardType[] {
      if (this.isSingleRow) {
        return [];
      }

      const middle = Math.ceil(this.quotes.length / 2);

      return this.quotes.slice(middle);
    },
  },
  mounted() {
    if (!this.disableAnimation) {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.setAnimationSpeed();
        });
      });
      window.addEventListener('resize', this.setAnimationSpeed);
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setAnimationSpeed);
  },
  methods: {
    setAnimationSpeed() {
      const speed = 30;

      const row1 = this.$refs.row1 as HTMLElement;
      const row2 = this.$refs.row2 as HTMLElement;

      const setup = (row: HTMLElement | undefined) => {
        if (!row) {
          return;
        }

        const wrapper = row.parentElement as HTMLElement;
        const gap = parseFloat(
          getComputedStyle(wrapper).columnGap ||
            getComputedStyle(wrapper).gap ||
            '0'
        );

        const width = row.scrollWidth + gap;
        const duration = width / speed;

        wrapper.style.setProperty('--scroll-width', `${width}px`);
        wrapper.style.setProperty('--duration', `${duration}s`);
      };

      setup(row1);
      setup(row2);
    },
  },
});
